export default "__VITE_ASSET__DPijwePF__"